import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";
import { fallback, object, optional, picklist } from "valibot";

export const Route = createFileRoute("/supporter/$supporterId/eap/requests/")({
  validateSearch: object({
    status: fallback(optional(picklist(["pending", "approved", "declined"])), "pending"),
  }),
  component: lazyRouteComponent(() => import("./+Requests")),
});
